import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectList } from "@common/selectList";
import { ColumnIcon } from "../columnIcon";
import { Props } from "./types";
import styles from "./styles.scss";

const fixedColumns = [
  "date",
  "resourceTask",
  "project",
  "timeSpent",
  "validation",
];

function Form({ lang, formData, edit }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "timeRecord",
  );
  const columns = [
    ...fixedColumns.map((key) => ({
      uuid: key,
      name: t(`timeRecordsListingConfiguration.columnNames.${key}`),
    })),
    ...template.map((criteria) => ({
      ...criteria,
      name: criteria.labels[lang as keyof typeof criteria.labels]
        ? criteria.labels[lang as keyof typeof criteria.labels]
        : criteria.name,
    })),
  ].filter(({ uuid }) => !formData.columns.find(({ key }) => key === uuid));

  return (
    <SelectList listClassName={styles.listRoot}>
      {({ select }) => ({
        input: (
          <div className={styles.input}>
            <p>{t("timeRecordsListingConfiguration.addColumn")}</p>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {columns.map((column) => (
              <div
                key={column.uuid}
                className={styles.item}
                onClick={() =>
                  edit({
                    ...formData,
                    columns: [...formData.columns, { key: column.uuid }],
                  })
                }
              >
                <ColumnIcon criteriaKey={column.uuid} className={styles.icon} />
                <p className={styles.name}>{column.name}</p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { Form };
